var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29557 18.2646L15.8958 8.66442L11.3359 4.1045L1.73565 13.7047C1.60348 13.8371 1.5096 14.0027 1.46395 14.1841L0.399902 19.6004L5.8152 18.5363C5.99702 18.4909 6.16334 18.3969 6.29557 18.2646V18.2646ZM18.995 5.56525C19.3823 5.17779 19.5999 4.65236 19.5999 4.1045C19.5999 3.55664 19.3823 3.03121 18.995 2.64375L17.3565 1.00532C16.9691 0.617985 16.4437 0.400391 15.8958 0.400391C15.3479 0.400391 14.8225 0.617985 14.435 1.00532L12.7966 2.64375L17.3565 7.20368L18.995 5.56525Z",
    fill: "#5C5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditar);
export default __webpack_public_path__ + "static/media/editar.55554f3f499b7cd78224b0772e4b02e2.svg";
export { ForwardRef as ReactComponent };